import { Injectable } from '@angular/core';
import {PromotionModel} from "../models/promotion.model";
import {BehaviorSubject, catchError, map, Observable, throwError} from "rxjs";
import {HttpClient} from "@angular/common/http";
import {ConfigService} from "./config.service";
import {ResponseModel, SuccessResponse} from "../models/response.model";
import {GameModel} from "../models/game.model";

@Injectable({
  providedIn: 'root'
})
export class PromotionService {

  staticPromotions: PromotionModel[];

  BASE_URL: string;
  CASINO_ID: number

  constructor(
    private http: HttpClient,
    private configs: ConfigService
  ) {
    this.BASE_URL = this.configs.apiUrl;
    this.CASINO_ID = this.configs.casinoId;

    this.staticPromotions = this.configs.publicPromotions;
  }

// get promotions for user
// TODO get API endpoints from Rival to CLAIM promotions + apply promo code and use these instead of iframe in account/userPromotion component

  getUserPromos(): Observable<PromotionModel[]>{
    //"method":"user.promotion.list" is deprecated since 2025 february
    return this.http.post<ResponseModel>(`${this.BASE_URL}`, {"jsonrpc":"2.0","id": this.CASINO_ID,"method":"promotion.list","params":{}}).pipe(
      map((response: ResponseModel)=> {
        if ('result' in response && 'promotions' in response.result){
          return response.result.promotions as PromotionModel[];
        }
        if ('error' in response) {
          throw new Error(response.error?.message || 'Unexpected error fetching promotions');
        }
        // If neither 'error' nor valid 'result' exists, throw an error
        throw new Error('Invalid response structure');
      }),
      catchError((error) => {
        return throwError(()=> error)
      })
    )

  }

}

